import React from 'react';
import NftCard from '../../components/NftCard';
import { PageWrapper } from './styles';

const cardData = [
  {
    id: 1234,
    author: {
      firstName: 'HiTek',
      lastName: 'Fiction',
      title: 'Freestyle 1 two 10',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1615484598/sCallProfiles/amadeu_test/131264041_3610524635697876_2474651660123494147_n_znwtwv.jpg',
    },
    coverMedia: {
      coverImageURL: 'https://res.cloudinary.com/scall/image/upload/v1615402376/sCallProfiles/amadeu_test/Screen_Shot_2021-03-10_at_1.52.46_PM_cl0wj9.png',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615485051/sCallProfiles/amadeu_test/dance-1_rocclq.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'Street Dance, Volume:1',
      number: '1/10',
    },
    details: {
      about: 'Nobody cares if you can’t dance well. Just get up and dance. Freestyle dancing makes you more comfortable in your own body, gives you the opportunity to explore new ideas for movement, and lets you let go and have fun expressing yourself! This dance is my “1 two 10” because it incorporates moves I made as a newbie, that I would call a “1", to right now as a nasty “10”.',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
  {
    id: 1534,
    author: {
      firstName: 'HiTek',
      lastName: 'Fiction',
      title: 'Working day & Night',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1615484598/sCallProfiles/amadeu_test/131264041_3610524635697876_2474651660123494147_n_znwtwv.jpg',
    },
    coverMedia: {
      coverImageURL: 'https://res.cloudinary.com/scall/image/upload/v1615402376/sCallProfiles/amadeu_test/Screen_Shot_2021-03-10_at_1.52.46_PM_cl0wj9.png',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615488598/sCallProfiles/amadeu_test/dance_2_jhke5s.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'Street Dance, Volume:1',
      number: '1/10',
    },
    details: {
      about: 'Nobody cares if you can’t dance well. Just get up and dance. Freestyle dancing makes you more comfortable in your own body, gives you the opportunity to explore new ideas for movement, and lets you let go and have fun expressing yourself! This dance is my “1 two 10” because it incorporates moves I made as a newbie, that I would call a “1", to right now as a nasty “10”.',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
  {
    id: 15654,
    author: {
      firstName: 'Johnny',
      lastName: 'Voltik',
      title: 'I gets busy, dassit',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1615554933/sCallProfiles/amadeu_test/voltikgram_152586308_3660830310632663_8862549078258178858_n_vaomqi.jpg',
    },
    coverMedia: {
      coverImageURL: '',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615488598/sCallProfiles/amadeu_test/dance_2_jhke5s.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'Freestyle, 1/10',
      number: '1/10',
    },
    details: {
      about: 'Nobody cares if you can’t dance well. Just get up and dance. Freestyle dancing makes you more comfortable in your own body, gives you the opportunity to explore new ideas for movement, and lets you let go and have fun expressing yourself! This dance is my “1 two 10” because it incorporates moves I made as a newbie, that I would call a “1", to right now as a nasty “10”.',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
];

const NftPage = () => (
  <PageWrapper>
    {cardData.map((c) => <NftCard key={c.id} cardData={c} />)}
  </PageWrapper>
);

export default NftPage;
